import { render, staticRenderFns } from "./posList.vue?vue&type=template&id=f8dbd1aa&scoped=true&"
import script from "./posList.vue?vue&type=script&lang=js&"
export * from "./posList.vue?vue&type=script&lang=js&"
import style0 from "./posList.vue?vue&type=style&index=0&id=f8dbd1aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8dbd1aa",
  null
  
)

export default component.exports